import React, { Component } from "react"
import * as styles from "./announceBountyContest.module.scss"
import ProgressiveImage from "react-progressive-image-loading"
import banner3bg from "../../../../assets/Home-BountyContest.png"
import banner3bgmin from "../../../../assets/Home-BountyContest.png"
import { TM } from "../../common/typography/trademark"

class AnnounceBountyContest extends Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.en = this.en.bind(this)
    this.ct = this.ct.bind(this)
  }

  render() {
    if (this.props.lang === "ct") {
      return this.ct()
    }

    return this.en()
  }

  en() {
    return (
      <ProgressiveImage
        preview={banner3bgmin}
        src={banner3bg}
        transitionTime={500}
        transitionFunction="ease"
        render={(src, style) => (
          <div
            className={styles.carouselGraphic3}
            style={Object.assign(style, { backgroundImage: `url(${src})` })}
          >
            <div className={styles.carouselText}></div>

            <section className={styles.carouselImg}>
              <div className={styles.announceHeading}>
                IronCAP
                <TM /> Bounty Contest 2021
              </div>

              <div className="styles.announceBody">
                <div>Registration begins: Feb 8, 2021 (EST)</div>

                <div>Contest begins: Feb 22, 2021 (EST)</div>

                <div>Contest ends: Mar 22, 2021 (EST)</div>
              </div>
            </section>
          </div>
        )}
      />
    )
  }

  ct() {
    return (
      <ProgressiveImage
        preview={banner3bgmin}
        src={banner3bg}
        transitionTime={500}
        transitionFunction="ease"
        render={(src, style) => (
          <div
            className={styles.carouselGraphic3}
            style={Object.assign(style, { backgroundImage: `url(${src})` })}
          >
            <div className={styles.carouselText}></div>

            <section className={styles.carouselImg}>
              <div className={styles.announceHeading}>
                IronCAP
                <TM /> 賞金比賽 2021
              </div>

              <div className="styles.announceBody">
                <div>接受註冊: 2021年2月8日 </div>

                <div>比賽開始: 2021年2月22日 </div>

                <div>比賽結束: 2021年3月22日</div>
              </div>
            </section>
          </div>
        )}
      />
    )
  }
}

export default AnnounceBountyContest
